var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "597px",
    height: "513px",
    viewBox: "0 0 597 513",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.3288382%",
    y1: "60.4682594%",
    x2: "100%",
    y2: "70.0746104%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C76F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.1446074%",
    y1: "50%",
    x2: "63.6111255%",
    y2: "66.3411608%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFE8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-27.3288382%",
    y1: "60.4118404%",
    x2: "100%",
    y2: "69.9664176%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77ECAB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-7.9%",
    y: "-10.6%",
    width: "115.8%",
    height: "121.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.6592113%",
    y1: "50%",
    x2: "56.2434762%",
    y2: "79.0764678%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFE8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.5409057%",
    y1: "68.5713921%",
    x2: "72.9274713%",
    y2: "85.6137009%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C76F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.522,0 L167.09752,0 C177.326938,-1.64974968e-14 185.61952,8.29258186 185.61952,18.522 L185.61952,366.982557 C185.61952,377.211975 177.326938,385.504557 167.09752,385.504557 L18.522,385.504557 C8.29258186,385.504557 5.42620445e-14,377.211975 5.65620158e-14,366.982557 L5.65620158e-14,18.522 C5.88619871e-14,8.29258186 8.29258186,-1.67360005e-15 18.522,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0178059506%",
    y1: "76.5677172%",
    x2: "81.7266583%",
    y2: "34.5162693%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88EFB6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.1100647%",
    y1: "31.3809088%",
    x2: "62.1100647%",
    y2: "-27.4779882%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.1650765%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.8082522%",
    y1: "88.1378177%",
    x2: "-20.0589142%",
    y2: "88.1378177%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4044",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.1440503%",
    y1: "57.4982836%",
    x2: "171.027698%",
    y2: "78.7115773%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D63A0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.4636132%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.4922248%",
    y1: "44.0719733%",
    x2: "69.1530929%",
    y2: "58.9362645%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#648BF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "-27.8185293%",
    x2: "50%",
    y2: "90.8575848%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Under-Maintenance",
    transform: "translate(-422.000000, -285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(422.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(31.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.745044,213.977237 L396.818014,213.805344 C402.34086,213.801126 406.821431,218.274858 406.825649,223.797703 C406.825653,223.8028 406.825653,223.807897 406.825649,223.812994 L406.700199,387.728365 C406.695977,393.24524 402.224715,397.716495 396.707839,397.720708 L171.634868,397.892602 C166.112023,397.89682 161.631452,393.423088 161.627234,387.900242 C161.62723,387.895145 161.62723,387.890048 161.627234,387.884951 L161.752684,223.969581 C161.756906,218.452705 166.228168,213.98145 171.745044,213.977237 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    opacity: 0.128510975,
    transform: "translate(284.226441, 305.848973) rotate(18.000000) translate(-284.226441, -305.848973) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.16743,71.8803727 L496.138656,71.6879365 C501.661502,71.6837186 506.142072,76.1574505 506.14629,81.6802964 C506.146294,81.6853932 506.146294,81.6904901 506.14629,81.6955869 L506.005624,265.493702 C506.001401,271.010578 501.530139,275.481833 496.013264,275.486046 L244.042038,275.678482 C238.519192,275.6827 234.038622,271.208968 234.034404,265.686122 C234.0344,265.681026 234.0344,265.675929 234.034404,265.670832 L234.17507,81.8727165 C234.179293,76.355841 238.650555,71.884586 244.16743,71.8803727 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    opacity: 0.216285342,
    transform: "translate(370.090347, 173.683209) rotate(18.000000) translate(-370.090347, -173.683209) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9975788,20.9077979 L155.424774,20.807424 C160.947619,20.803206 165.42819,25.2769379 165.432408,30.7997838 C165.432412,30.8048807 165.432412,30.8099775 165.432408,30.8150744 L165.360978,124.146702 C165.356756,129.663577 160.885494,134.134832 155.368618,134.139045 L23.9414236,134.239419 C18.4185777,134.243637 13.9380072,129.769905 13.9337893,124.247059 C13.9337854,124.241963 13.9337854,124.236866 13.9337893,124.231769 L14.005219,30.9001417 C14.0094412,25.3832662 18.4807033,20.9120113 23.9975788,20.9077979 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    opacity: 0.226655506,
    filter: "url(#filter-4)",
    transform: "translate(89.683099, 77.523422) rotate(18.000000) translate(-89.683099, -77.523422) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.710113,364.921212 L478.419933,364.877902 C483.942779,364.873684 488.423349,369.347416 488.427567,374.870262 C488.427571,374.875358 488.427571,374.880455 488.427567,374.885552 L488.356137,468.217179 C488.351915,473.734055 483.880653,478.20531 478.363778,478.209523 L421.653957,478.252834 C416.131112,478.257051 411.650541,473.78332 411.646323,468.260474 C411.646319,468.255377 411.646319,468.25028 411.646323,468.245183 L411.717753,374.913556 C411.721975,369.396681 416.193237,364.925426 421.710113,364.921212 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    opacity: 0.216285342,
    transform: "translate(450.036945, 421.565368) rotate(18.000000) translate(-450.036945, -421.565368) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.263548,264.905538 L545.067577,264.881248 C550.590423,264.87703 555.070993,269.350762 555.075211,274.873608 C555.075215,274.878705 555.075215,274.883802 555.075211,274.888899 L555.031933,331.437448 C555.027711,336.954324 550.556448,341.425578 545.039573,341.429792 L513.235544,341.454081 C507.712698,341.458299 503.232128,336.984567 503.22791,331.461721 C503.227906,331.456625 503.227906,331.451528 503.22791,331.446431 L503.271188,274.897881 C503.27541,269.381006 507.746673,264.909751 513.263548,264.905538 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    opacity: 0.128510975,
    transform: "translate(529.151561, 303.167665) rotate(18.000000) translate(-529.151561, -303.167665) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud-Storage",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone1",
    transform: "translate(131.010677, -0.265700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.137,0 L175.6217,0 C189.504482,-6.10293932e-15 200.7587,11.2542182 200.7587,25.137 L200.7587,391.593791 C200.7587,405.476573 189.504482,416.730791 175.6217,416.730791 L25.137,416.730791 C11.2542182,416.730791 3.15183647e-14,405.476573 -2.82810079e-14,391.593791 L-2.82810079e-14,25.137 C-3.3533872e-14,11.2542182 11.2542182,-1.00248804e-15 25.137,0 Z",
    id: "Rectangle",
    fillOpacity: 0.225360577,
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(7.240478, 18.349990)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.642072771,
    fill: "#68DE9E",
    mask: "url(#mask-8)",
    cx: 84.3040767,
    cy: 221.997265,
    rx: 15.9207921,
    ry: 15.9236277
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.372146,222.992492 C62.8249351,222.992492 97.2397203,257.413406 97.2397203,299.873757 C97.2397203,342.334107 62.8249351,376.755021 20.372146,376.755021 C-22.080643,376.755021 -56.4954282,342.334107 -56.4954282,299.873757 C-56.4954282,257.413406 -22.080643,222.992492 20.372146,222.992492 Z M20.372146,256.581394 C-3.53330797,256.581394 -22.9125074,275.964045 -22.9125074,299.873757 C-22.9125074,323.783468 -3.53330797,343.166119 20.372146,343.166119 C44.2776,343.166119 63.6567995,323.783468 63.6567995,299.873757 C63.6567995,275.964045 44.2776,256.581394 20.372146,256.581394 Z",
    id: "Oval",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.221631,6.79802599 C120.938977,6.79802599 122.331161,8.13476054 122.331161,9.78370618 C122.331161,11.3960086 121.000164,12.7098218 119.335628,12.7674173 L119.221631,12.7693864 L64.1594794,12.7693864 C62.4421336,12.7693864 61.0499497,11.4326518 61.0499497,9.78370618 C61.0499497,8.17140378 62.3809462,6.85759059 64.0454831,6.79999509 L64.1594794,6.79802599 L119.221631,6.79802599 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.335222,6.30041262 C131.052568,6.30041262 132.444752,7.69284445 132.444752,9.41049615 C132.444752,11.0899778 131.113755,12.4585332 129.449218,12.5185285 L129.335222,12.5205797 L129.172126,12.5205797 C127.454781,12.5205797 126.062597,11.1281479 126.062597,9.41049615 C126.062597,7.73101449 127.393593,6.36245908 129.05813,6.30246377 L129.172126,6.30041262 L129.335222,6.30041262 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(307.010677, 218.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L36.3642194,0 L36.3642194,0 L48,12 L48,51 C48,54.3137085 45.3137085,57 42,57 L6,57 C2.6862915,57 4.05812251e-16,54.3137085 0,51 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#FB9C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.041,42 L10.041,37.23 L13.065,37.23 C14.445,37.23 15.519,36.882 16.287,36.186 C17.055,35.49 17.439,34.518 17.439,33.27 C17.439,32.022 17.055,31.05 16.287,30.354 C15.519,29.658 14.445,29.31 13.065,29.31 L13.065,29.31 L7.233,29.31 L7.233,42 L10.041,42 Z M12.705,35.106 L10.041,35.106 L10.041,31.452 L12.705,31.452 C13.413,31.452 13.941,31.602 14.289,31.902 C14.637,32.202 14.811,32.664 14.811,33.288 C14.811,34.5 14.109,35.106 12.705,35.106 L12.705,35.106 Z M24.189,42 C25.581,42 26.775,41.748 27.771,41.244 C28.767,40.74 29.526,40.011 30.048,39.057 C30.57,38.103 30.831,36.966 30.831,35.646 C30.831,34.326 30.567,33.192 30.039,32.244 C29.511,31.296 28.749,30.57 27.753,30.066 C26.757,29.562 25.569,29.31 24.189,29.31 L24.189,29.31 L19.257,29.31 L19.257,42 L24.189,42 Z M23.991,39.732 L22.065,39.732 L22.065,31.578 L23.991,31.578 C26.691,31.578 28.041,32.934 28.041,35.646 C28.041,38.37 26.691,39.732 23.991,39.732 L23.991,39.732 Z M35.763,42 L35.763,36.654 L41.199,36.654 L41.199,34.44 L35.763,34.44 L35.763,31.524 L41.559,31.524 L41.559,29.31 L32.991,29.31 L32.991,42 L35.763,42 Z",
    id: "PDF",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,12 L39.3642194,12 C37.7073651,12 36.3642194,10.6568542 36.3642194,9 L36.3642194,0 L36.3642194,0 L48,12 Z",
    id: "Path",
    fill: "#EA5455",
    fillRule: "nonzero",
    opacity: 0.339960007
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(169.010677, 294.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L36.3642194,0 L36.3642194,0 L48,12 L48,51 C48,54.3137085 45.3137085,57 42,57 L6,57 C2.6862915,57 4.05812251e-16,54.3137085 0,51 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#FFBC7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,32 L15.5,32 C15.7761424,32 16,32.2238576 16,32.5 L16,46.5 C16,46.7761424 15.7761424,47 15.5,47 L8.5,47 C8.22385763,47 8,46.7761424 8,46.5 L8,32.5 C8,32.2238576 8.22385763,32 8.5,32 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,22 L27.5,22 C27.7761424,22 28,22.2238576 28,22.5 L28,46.5 C28,46.7761424 27.7761424,47 27.5,47 L20.5,47 C20.2238576,47 20,46.7761424 20,46.5 L20,22.5 C20,22.2238576 20.2238576,22 20.5,22 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,29 L39.5,29 C39.7761424,29 40,29.2238576 40,29.5 L40,46.5 C40,46.7761424 39.7761424,47 39.5,47 L32.5,47 C32.2238576,47 32,46.7761424 32,46.5 L32,29.5 C32,29.2238576 32.2238576,29 32.5,29 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,12 L39.3642194,12 C37.7073651,12 36.3642194,10.6568542 36.3642194,9 L36.3642194,0 L36.3642194,0 L48,12 Z",
    id: "Path",
    fill: "#FC9735",
    fillRule: "nonzero",
    opacity: 0.732677641
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(237.010677, 257.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L36.3642194,0 L36.3642194,0 L48,12 L48,51 C48,54.3137085 45.3137085,57 42,57 L6,57 C2.6862915,57 4.05812251e-16,54.3137085 0,51 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#B7B0FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(11.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29131402,22.9500078 C7.94228082,22.9500078 10.091314,20.8009746 10.091314,18.1500078 C10.091314,15.499041 7.94228082,13.3500078 5.29131402,13.3500078 C2.64034722,13.3500078 0.49131402,15.499041 0.49131402,18.1500078 C0.49131402,20.8009746 2.64034722,22.9500078 5.29131402,22.9500078 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,20.8782658 C19.4509668,20.8782658 21.6,18.7292326 21.6,16.0782658 C21.6,13.427299 19.4509668,11.2782658 16.8,11.2782658 C14.1490332,11.2782658 12,13.427299 12,16.0782658 C12,18.7292326 14.1490332,20.8782658 16.8,20.8782658 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "21.6 0.603660159 21.6 15.7171024 19.8 15.7171024 19.7992674 4.27806792 10.0768674 7.42926792 10.0768674 18.0060621 8.27686739 18.0060621 8.27779422 4.92070694"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48,12 L39.3642194,12 C37.7073651,12 36.3642194,10.6568542 36.3642194,9 L36.3642194,0 L36.3642194,0 L48,12 Z",
    id: "Path",
    fill: "#564EA6",
    fillRule: "nonzero",
    opacity: 0.339960007
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(231.010677, 135.234300) scale(-1, 1) translate(-231.010677, -135.234300) translate(169.010677, 63.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.640832,0 L112.795648,0 C118.733814,-1.09082333e-15 123.547648,4.81383437 123.547648,10.752 L123.547648,131.612444 C123.547648,137.55061 118.733814,142.364444 112.795648,142.364444 L11.640832,142.364444 C5.70266637,142.364444 0.888832,137.55061 0.888832,131.612444 L0.888832,10.752 C0.888832,4.81383437 5.70266637,2.86718017e-15 11.640832,0 Z",
    id: "Rectangle",
    fill: "#00CFE8",
    opacity: 0.272832961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.918016,10.6773333 L102.129664,10.6773333 C108.06783,10.6773333 112.881664,15.4911677 112.881664,21.4293333 L112.881664,31.6792778 C112.881664,37.6174434 108.06783,42.4312778 102.129664,42.4312778 L20.918016,42.4312778 C14.9798504,42.4312778 10.166016,37.6174434 10.166016,31.6792778 L10.166016,21.4293333 C10.166016,15.4911677 14.9798504,10.6773333 20.918016,10.6773333 Z",
    id: "Rectangle",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5370993,16.016 L28.9037327,16.016 C34.6624518,16.016 39.330816,20.6843642 39.330816,26.4430833 C39.330816,32.2018024 34.6624518,36.8701667 28.9037327,36.8701667 L27.5370993,36.8701667 C21.7783802,36.8701667 17.110016,32.2018024 17.110016,26.4430833 C17.110016,20.6843642 21.7783802,16.016 27.5370993,16.016 Z",
    id: "Rectangle",
    fillOpacity: 0.21017264,
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.918016,52.3856667 L102.129664,52.3856667 C108.06783,52.3856667 112.881664,57.199501 112.881664,63.1376667 L112.881664,73.3876111 C112.881664,79.3257767 108.06783,84.1396111 102.129664,84.1396111 L20.918016,84.1396111 C14.9798504,84.1396111 10.166016,79.3257767 10.166016,73.3876111 L10.166016,63.1376667 C10.166016,57.199501 14.9798504,52.3856667 20.918016,52.3856667 Z",
    id: "Rectangle",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5370993,57.7243333 L28.9037327,57.7243333 C34.6624518,57.7243333 39.330816,62.3926976 39.330816,68.1514167 C39.330816,73.9101358 34.6624518,78.5785 28.9037327,78.5785 L27.5370993,78.5785 C21.7783802,78.5785 17.110016,73.9101358 17.110016,68.1514167 C17.110016,62.3926976 21.7783802,57.7243333 27.5370993,57.7243333 Z",
    id: "Rectangle",
    fillOpacity: 0.21017264,
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.918016,94.094 L102.129664,94.094 C108.06783,94.094 112.881664,98.9078344 112.881664,104.846 L112.881664,115.095944 C112.881664,121.03411 108.06783,125.847944 102.129664,125.847944 L20.918016,125.847944 C14.9798504,125.847944 10.166016,121.03411 10.166016,115.095944 L10.166016,104.846 C10.166016,98.9078344 14.9798504,94.094 20.918016,94.094 Z",
    id: "Rectangle",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5370993,99.4326667 L28.9037327,99.4326667 C34.6624518,99.4326667 39.330816,104.101031 39.330816,109.85975 C39.330816,115.618469 34.6624518,120.286833 28.9037327,120.286833 L27.5370993,120.286833 C21.7783802,120.286833 17.110016,115.618469 17.110016,109.85975 C17.110016,104.101031 21.7783802,99.4326667 27.5370993,99.4326667 Z",
    id: "Rectangle",
    fillOpacity: 0.21017264,
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(394.010677, 49.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0.7056 L10.295487,0.7056 C12.504626,0.7056 14.295487,2.496461 14.295487,4.7056 L14.295487,7.53965428 C14.295487,8.21304226 14.8413758,8.75893108 15.5147638,8.75893108 L60.9264896,8.75893108 C63.1356286,8.75893108 64.9264896,10.5497921 64.9264896,12.7589311 L64.9264896,51.573056 C64.9264896,53.782195 63.1356286,55.573056 60.9264896,55.573056 L4,55.573056 C1.790861,55.573056 -2.83808297e-15,53.782195 0,51.573056 L0,4.7056 C-2.705415e-16,2.496461 1.790861,0.7056 4,0.7056 Z",
    id: "Rectangle",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6069291,4.51584 L66.2013193,4.51584 C66.8747073,4.51584 67.4205961,5.06172882 67.4205961,5.7351168 C67.4205961,5.79943567 67.4155067,5.86365371 67.4053756,5.92716968 L59.9543368,52.6407121 C59.8599469,53.2324802 59.3495292,53.667936 58.7502805,53.667936 L9.15589031,53.667936 C8.48250233,53.667936 7.93661351,53.1220472 7.93661351,52.4486592 C7.93661351,52.3843403 7.94170289,52.3201223 7.95183399,52.2566063 L15.4028728,5.54306392 C15.4972627,4.95129575 16.0076804,4.51584 16.6069291,4.51584 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6208087,21.7618168 L67.1850722,49.7188915 C66.4541691,53.4780714 63.1617061,56.192032 59.33213,56.192032 L4.85263196,56.192032 C2.64349296,56.192032 0.852631956,54.401171 0.852631956,52.192032 C0.852631956,51.9357877 0.877254757,51.6801362 0.92616089,51.4286023 L6.36189744,23.4715276 C7.09280052,19.7123477 10.3852635,16.9983871 14.2148396,16.9983871 L68.6943376,16.9983871 C70.9034766,16.9983871 72.6943376,18.7892481 72.6943376,20.9983871 C72.6943376,21.2546314 72.6697148,21.5102828 72.6208087,21.7618168 Z",
    id: "Rectangle",
    fill: "#FABB7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(360.010677, 140.734300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L62,0 C65.3137085,1.44626758e-15 68,2.6862915 68,6 L68,51 C68,54.3137085 65.3137085,57 62,57 L6,57 C2.6862915,57 3.9323804e-15,54.3137085 0,51 L0,6 C-1.29399067e-15,2.6862915 2.6862915,-2.79460044e-16 6,0 Z",
    id: "Rectangle",
    fill: "#77ECAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,20.3055467 L26,36.6632601 C26,37.1141896 26.3655505,37.4797401 26.81648,37.4797401 C26.9461329,37.4797401 27.0739218,37.4488638 27.1892714,37.3896665 L43.5469848,28.9948954 C43.948168,28.7890084 44.1064868,28.2968808 43.9005998,27.8956977 C43.8199246,27.7384973 43.6904308,27.6117098 43.5315618,27.5343723 L27.1738484,19.5714299 C26.7684069,19.3740608 26.2797323,19.5427368 26.0823632,19.9481783 C26.0281648,20.0595143 26,20.1817195 26,20.3055467 Z",
    id: "Path-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7,
    y: 5,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 19,
    y: 5,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 31,
    y: 5,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 43,
    y: 5,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 55,
    y: 5,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7,
    y: 45,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 19,
    y: 45,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 31,
    y: 45,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 43,
    y: 45,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 55,
    y: 45,
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men3.6",
    transform: "translate(93.010677, 258.234300) scale(-1, 1) translate(-93.010677, -258.234300) translate(0.010677, 94.734300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head1",
    transform: "translate(104.935829, 10.404961) scale(-1, 1) translate(-104.935829, -10.404961) translate(87.529412, 0.465751)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(105.433155, 126.693715)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B8B6C9",
    points: "42.1519328 172.764691 45.7553427 194.520946 33.3268603 194.454697 32.9066823 172.423564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.741879,186.307936 L46.8298928,188.140897 C48.1569801,189.608118 48.7243632,192.640776 48.5320423,197.238872 C48.5320423,200.314997 30.7501958,200.22365 29.7636143,197.238872 C29.42695,192.248504 30.0316294,189.150561 31.5776523,187.945043 L31.5872849,186.174592 C31.5935321,185.026358 32.3707937,184.023857 33.4860602,183.72558 L35.7364671,183.123709 C37.6782585,180.300701 40.3246153,180.40043 42.592284,183.476697 L44.7243763,183.937362 C45.8589991,184.182512 46.6865106,185.154841 46.741879,186.307936 Z",
    id: "Path",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.25525478 C0,1.25525478 16.0698292,89.5354189 18.8876326,98.7284452 C20.7661682,104.857129 24.3102922,130.969805 29.5200047,177.066472 L46.3996009,177.114623 C46.6393606,141.629877 46.1908758,121.036061 45.0541464,115.333175 C43.3490524,106.778846 39.500149,92.6904372 39.500149,92.6904372 C39.500149,92.6904372 36.6404842,41.5454465 34.9296285,29.6147147 C33.2193574,17.6839829 27.7284869,0 27.7284869,0 L0,1.25525478 Z",
    id: "Path",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.230327,66.7430959 L10.6881509,54.7272942 L11.8164493,58.0355691 C17.4340652,74.6094556 21.2536885,87.4748888 23.2753192,96.6318687 C24.9766228,104.337927 25.3343007,117.641643 24.3483528,136.543018 L23.2276665,127.28128 C21.6118624,114.165055 20.0408646,102.654329 18.9301255,98.870167 L18.8203641,98.5026688 C17.7765464,94.9082962 15.17616,82.0174353 12.230327,66.7430959 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(72.609626, 127.687636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1492744,174.862763 L22.805322,174.93858 L22.8021735,175.256678 C22.7647188,176.818793 22.3391362,183.708746 17.7841146,186.353724 L16.8752378,186.890347 C11.7461226,189.963412 4.65025895,194.905897 4.65025895,194.905897 L35.0150397,195.93876 L34.1492744,174.862763 Z",
    id: "Path",
    fill: "#B8B6C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5795032,182.579458 C35.2392823,182.334729 36.5691719,187.43679 36.5691719,197.88564 L22.9512037,197.935718 L22.0284254,195.93876 L21.161318,196.287147 C19.3146914,197.01259 18.0032557,197.413024 17.227011,197.48845 L16.5064192,197.55449 C12.6883069,197.884375 7.39685134,198.03881 0.63205236,198.017794 L0.609568944,197.900935 C0.495020068,197.192914 0.191756024,193.411986 6.07198495,190.53867 L6.34779398,190.406715 C13.0515336,187.265525 17.9635423,182.829873 19.0242711,182.239448 L19.0756912,182.212365 C20.0256714,181.744932 19.4059636,181.480624 20.7558036,182.579458 C22.1056435,183.677477 22.3278731,186.565282 25.3865086,186.655832 C29.3233332,186.772486 28.5898344,182.946552 32.5795032,182.579458 Z",
    id: "Path",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2990105,41.8685544 C43.9482221,57.5568691 40.401854,95.8678503 40.401854,95.8678503 C40.401854,95.8678503 40.001419,99.9036546 41.7346834,111.083766 C42.890193,118.537173 41.1914403,140.39778 36.6384254,176.665587 L18.662361,176.702246 C17.1841916,127.979878 16.4100447,101.056464 16.3399204,95.9320032 C16.1757834,83.9470639 12.2887566,0.851484739 12.2887566,0.851484739 L49.6751033,0 C49.6751033,0 52.6497988,26.1802397 48.2990105,41.8685544 Z",
    id: "Path",
    fill: "#353160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0864291,32.2983245 L22.0158532,32.605385 C19.4333996,43.4651618 23.8621962,91.5929726 22.6013525,103.036506 L22.0991856,107.130746 C21.2227159,114.488215 19.7395939,127.901029 17.6498195,147.36919 L17.1965208,131.073356 C16.7804587,115.587207 16.4267114,101.015127 16.3501777,96.5829097 L16.3399204,95.9320032 C16.1757834,83.9470639 12.2887566,0.851484739 12.2887566,0.851484739 L19.2828511,0.693089871 L19.5886683,2.03705558 C22.676044,15.8059339 23.5086309,25.8930235 22.0864291,32.2983245 L22.0864291,32.2983245 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.1766687,
    y1: 185.314778,
    x2: 15.3160823,
    y2: 183.82178,
    id: "Path-47",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.640305,
    y1: 187.02108,
    x2: 12.7797186,
    y2: 185.528082,
    id: "Path-47",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1039414,
    y1: 188.727382,
    x2: 10.243355,
    y2: 187.234384,
    id: "Path-47",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(86.534759, 0.465751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49905078,19.7038267 C3.59426301,20.130708 3.87109498,26.9905098 8.62444558,27.3486708 C9.59598009,33.9615454 13.0607507,37.1121972 17.2849152,37.4767643 L17.0506279,47.4790647 L35.7353288,47.4679996 C35.7353288,47.4679996 30.473773,40.4020368 30.7360348,30.7287786 C30.9982967,21.054938 30.560028,11.9675496 30.560028,11.9675496 L6.35908588,12.4014194 L7.49905078,19.7038267 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7302438,15.628908 C30.4139169,16.4416473 29.0735082,20.1146478 28.220949,20.1146478 C24.3097582,18.5690673 21.0670893,24.1341135 19.4186836,29.7233072 C14.7373107,34.3128002 4.39382785,34.4144475 3.32522206,30.5752394 C-0.720436934,22.1664781 -0.918861813,10.0077636 3.80225724,9.06947214 C0.0962621957,-0.702018862 50.1461072,-5.81361244 28.7302438,15.628908 Z",
    id: "Path",
    fill: "url(#linearGradient-12)",
    transform: "translate(17.177497, 16.978884) scale(-1, 1) translate(-17.177497, -16.978884) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80443086,31.0955276 C9.99659462,30.6743053 11.1428879,33.5585959 12.9958446,35.1047378 C14.9133766,36.7047624 17.7918028,37.1733219 17.2849152,37.4767643 C13.3946182,39.8056457 8.23828785,34.5285072 9.80443086,31.0955276 Z",
    id: "Path-45",
    fill: "url(#linearGradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(124.331551, 37.240827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.16709,29.3319459 C44.16709,29.3319459 43.3462158,23.8045906 43.6067643,20.167533 C44.0886327,13.4409442 43.1670521,7.76657858 44.65657,6.88393807 C46.567064,5.7518431 47.0448339,15.7954239 47.0448339,15.7954239 C47.0448339,15.7954239 57.9556695,-1.96619698 60.2303459,0.1799217 C62.5050224,2.3254616 57.7601117,11.6594573 58.5124822,14.3583115 C59.2648526,17.0565869 51.7464174,30.1104059 51.7464174,30.1104059 L44.16709,29.3319459 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83367592,32.5250788 C3.83367592,32.5250788 20.3606497,58.2316218 24.0118421,63.2172384 C27.8416127,68.4453641 34.6053354,70.7604867 39.4052834,62.4196786 C43.6507606,55.040804 52.7412695,36.5638103 53.8917816,30.819991 C54.750128,26.534699 45.9582252,20.1472757 41.7326551,26.5509049 C37.5070849,32.9539553 30.8335295,42.5831291 30.8335295,42.5831291 C30.8335295,42.5831291 19.8594597,22.7020135 16.4383697,18.0109962 C7.21260976,5.36058738 -6.84412974,16.7203154 3.83367592,32.5250788 Z",
    id: "Path",
    fill: "#02C4DC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000",
    points: "30.8335295 42.5831291 34.4648149 48.8351178 33.1415796 39.1851079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9346608,27.1181215 C45.6801282,25.6393716 49.2322744,26.0386616 52.3605023,30.5561552",
    id: "Path-54",
    stroke: "#5386BF",
    strokeLinecap: "round",
    transform: "translate(47.147582, 28.452184) rotate(4.000000) translate(-47.147582, -28.452184) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(80.566845, 41.216511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6789681,1.85440975 L20.3720294,1.97934226 L19.5817516,2.29754125 C16.3968353,3.60356842 4.56856543,8.68929165 2.36499755,13.0446598 C-1.31701656,20.3221877 3.53413551,78.629496 1.41929732,82.1480074 C-3.04195427,89.5705925 2.78567505,94.6891442 22.149456,96.6256891 L22.7403839,96.6833974 C42.5763131,98.5744806 60.1740935,97.0258703 56.9807787,87.0204701 C53.786638,77.0142325 63.5594147,12.567441 54.3951478,8.11576836 C44.5843613,3.94152929 39.6789681,1.85440975 39.6789681,1.85440975 Z",
    id: "Path",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8572687,16.6215155 C21.7176069,22.8483552 16.036271,39.0533884 1.81326097,65.2366151 L1.63730358,59.3876344 C1.17208436,44.7872534 0.487645088,26.9904751 1.34668048,18.0344066 C10.3301633,11.2357805 16.1666343,10.7641143 18.8572687,16.6215155 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0731759,0.145563165 C20.274293,-0.181953957 40.3870946,0.145563165 41.1861729,0.145563165 C41.9852512,0.145563165 41.9852512,3.56325633 41.1861729,3.56325633 C40.6975463,3.56325633 34.4600651,3.47017943 19.0717299,3.28402562 C18.1459983,3.27282698 16.4483467,3.79064354 13.978775,4.8374753 C16.5742976,1.92787863 18.2724313,0.363907914 19.0731759,0.145563165 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 48.173958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6158765,52.5867317 C21.6158765,52.5867317 11.0860947,54.2585259 9.09979362,52.6165852 C7.11349255,50.9752298 -0.7985388,39.8147158 0.0657029471,37.8941427 C0.929944695,35.974155 8.1488367,40.0353973 8.76399059,38.814332 C9.55490274,37.2455615 5.4723062,31.6489144 9.04974325,31.3228677 C9.97101914,31.2385755 10.6216739,34.6834316 13.2155631,36.9522951 C15.8088703,39.221744 22.0692396,44.2552728 22.0692396,44.2552728 L21.6158765,52.5867317 Z",
    id: "Path",
    fill: "url(#linearGradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2500088,3.45728972 C76.1501543,12.1159661 63.2654281,32.5620793 60.5202238,34.3632385 C57.7744376,36.1649831 23.4305763,39.7981139 20.19709,42.7307781 C17.4961163,45.1805185 17.2528482,52.6341461 20.19709,54.701645 C23.1419137,56.769144 61.8091454,53.997538 68.9005836,51.9312098 C75.9926037,49.8654669 88.1395443,30.9317622 93.565353,25.0220299 C108.739358,8.49466747 94.3498633,-5.20080126 85.2500088,3.45728972 Z",
    id: "Path",
    fill: "#02C4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7697865,41.5306056 C22.0692396,43.5198244 21.211374,46.4189736 22.0692396,52.0826817",
    id: "Path-53",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderMaintenance);
export default __webpack_public_path__ + "static/media/under-maintenance.2660be57857c538a520d8794aff93d4a.svg";
export { ForwardRef as ReactComponent };